import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { Title } from 'components/Misc/Typography';
import { useBlankCourseStore } from 'store/blank/useBlankCourseStore';

const Overlay = ({ active }) => {
	const course = useBlankCourseStore(state => state.courses.find(c => c.id === active));

	return (
		<DragOverlay modifiers={[restrictToWindowEdges]}>
			<Show if={active}>
				<div className="py-2 px-3 flex items-center space-x-2 bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
					<Icon
						icon="drag_indicator"
						className="text-neutral-800 dark:text-white cursor-move transition-colors"
					/>

					<Title
						title={course?.title}
						subtitle={course?.subject?.title}
						className="flex-1"
					/>
				</div>
			</Show>
		</DragOverlay>
	);
};

export default Overlay;